import React from 'react';
import styled from 'styled-components';
import { ChangeEvent } from 'react';

const AreaBox = styled.div<{ boxWidth?: number }>`
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: ${(props) => `${props.boxWidth}%`};
`;
const AreaLabel = styled.label<{ labelWidth?: number }>`
    font-size: 20px;
    width: ${(props) => `${props.labelWidth}%`};
    color: #666;
    @media ${(props) => props.theme.device.laptop} {
        font-size: 16px;
        min-width: 80px;
    }
    @media ${(props) => props.theme.device.mobile} {
        font-size: 12px;
        min-width: 50px;
    }
`;

const AreaInput = styled.textarea<{ inputWidth?: number; inputHeight?: number }>`
    width: ${(props) => `${props.inputWidth}%`};
    height: ${(props) => `${props.inputHeight}px`};
    resize: none;
    font-size: 14px;
    border-radius: 5px;
    border-color: #dcdcdc;
    padding: 4px;
    padding-top: 12px;
    margin-top: 12px;
    padding-left: 12px;
    box-sizing: border-box;
    @media ${(props) => props.theme.device.laptop} {
        width: 80%;
    }
`;

interface TextAreaProps {
    boxWidth: number;
    labelWidth?: number;
    inputWidth?: number;
    inputHeight?: number;
    onChange: (event: ChangeEvent<HTMLTextAreaElement>) => void;
    htmlFor: string;
    labelName: string;
    name: string;
    placeholder?: string;
    maxLength?: number;
    isRequired: boolean;
}

function TextArea(props: TextAreaProps) {
    const {
        boxWidth,
        labelWidth,
        inputWidth,
        inputHeight,
        onChange,
        htmlFor,
        labelName,
        name,
        placeholder,
        maxLength,
    } = props;

    return (
        <AreaBox boxWidth={boxWidth}>
            <AreaLabel labelWidth={labelWidth} htmlFor={htmlFor}>
                {labelName}
            </AreaLabel>
            <AreaInput
                inputWidth={inputWidth}
                inputHeight={inputHeight}
                onChange={onChange}
                name={name}
                placeholder={placeholder}
                required
                maxLength={maxLength}
            />
        </AreaBox>
    );
}

export default TextArea;
